import React from 'react';

import DataModelView from '../../common/view/DataModelView';

export default class GeneralSummaryView extends DataModelView {
  getIntegratedPropertyNames() {
    return [];
  }

  render() {
    return (<div />);
  }
}